import { Outlet, useNavigate, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import logo from "../assets/sg-logo.png";

export default function AppLayout() {
  const navigate = useNavigate();
  const location = useLocation();

  const [isAdmin, setIsAdmin] = useState(false);

  // 🔐 Sync admin state from localStorage
  useEffect(() => {
    setIsAdmin(localStorage.getItem("isAdminLoggedIn") === "true");
  }, [location.pathname]);

  const handleLogout = () => {
    localStorage.removeItem("isAdminLoggedIn");
    setIsAdmin(false);
    navigate("/admin/login");
  };

  return (
    <div className="min-h-screen bg-slate-50 flex flex-col">
      {/* ================= NAVBAR ================= */}
      <header className="bg-white border-b border-slate-200 sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 py-4 flex items-center justify-between">

          {/* BRAND */}
          <div
            onClick={() => navigate("/")}
            className="flex items-center gap-3 cursor-pointer"
          >
            <img
              src={logo}
              alt="SmartGoNext Logo"
              className="h-10 w-10 rounded-full object-contain"
            />
            <div className="leading-tight">
              <p className="font-semibold text-slate-900">SmartGoNext</p>
              <p className="text-xs text-slate-500">
                Internship Verification Portal
              </p>
            </div>
          </div>

          {/* NAV ACTIONS */}
          <div className="flex items-center gap-5 text-sm font-medium">

            {/* Verify always visible */}
            <button
              onClick={() => navigate("/verify")}
              className={`transition ${
                location.pathname === "/verify"
                  ? "text-indigo-600 font-semibold"
                  : "text-slate-600 hover:text-indigo-600"
              }`}
            >
              Verify Certificate
            </button>

            {/* Apply always visible */}
            <button
              onClick={() => navigate("/apply")}
              className={`transition ${
                location.pathname === "/apply"
                  ? "text-indigo-600 font-semibold"
                  : "text-slate-600 hover:text-indigo-600"
              }`}
            >
              Apply for Internship
            </button>

            {/* Admin Logged In */}
            {isAdmin ? (
              <>
                <button
                  onClick={() => navigate("/admin/dashboard")}
                  className={`transition ${
                    location.pathname.startsWith("/admin/dashboard")
                      ? "text-indigo-600 font-semibold"
                      : "text-slate-600 hover:text-indigo-600"
                  }`}
                >
                  Dashboard
                </button>

                <button
                  onClick={handleLogout}
                  className="px-4 py-2 bg-red-500 text-white rounded-xl hover:bg-red-600 transition shadow-sm"
                >
                  Logout
                </button>
              </>
            ) : (
              <button
                onClick={() => navigate("/admin/login")}
                className="px-4 py-2 bg-indigo-600 text-white rounded-xl hover:bg-indigo-700 transition shadow-sm"
              >
                Admin
              </button>
            )}
          </div>
        </div>
      </header>

      {/* ================= PAGE CONTENT ================= */}
      <main className="flex-1">
        <div className="max-w-7xl mx-auto px-4 py-8">
          <Outlet />
        </div>
      </main>

      {/* ================= FOOTER ================= */}
      <footer className="bg-white border-t border-slate-200">
        <div className="max-w-7xl mx-auto px-4 py-4 text-sm text-slate-500 flex flex-col sm:flex-row justify-between gap-2">
          <span>
            © {new Date().getFullYear()} SmartGoNext — Internship Verification Portal. All rights reserved.
          </span>
          <span>Powered by SmartGoNext Software Solutions</span>
        </div>
      </footer>
    </div>
  );
}
